import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=24112bb8&scoped=true&"
import script from "./chat.vue?vue&type=script&lang=js&"
export * from "./chat.vue?vue&type=script&lang=js&"
import style0 from "./chat.vue?vue&type=style&index=0&id=24112bb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24112bb8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ChatArea: require('/home/circleci/repo/components/chat/ChatArea.vue').default})
